import React from 'react';
import { Navigate } from 'react-router';
import { NavLink } from 'react-router-dom';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import SelectAsync from 'react-select/async';
import DatePicker from 'react-datepicker2';

export default class WarehouseIOReport extends Base {
	constructor(props) {
		super(props);
		this.state = {
			data: null,
			loading: true,
			fromDate: null,
			toDate: null,
			accountId: null
		}
	}
	componentDidMount() {
		this.getData();
	}
	getData() {

		this.httpPost("api/v1/report/warehouseio")
			.then(data => {
				if (data.status === -1) window.location.href = "/login";
				if (data.status === 1) {
					this.setState({
						data: data,
						loading: false
					})
				}
				else {
					this.showErorrMessage(data.message);
					this.setState({
						loading: false
					});
				}
			});
	}
	renderForm() {
		return <div className="container">

			<div className="row">
				<div className="col-sm-12">
					<div className="panel panel-info">
						<div className="panel-body">
							<div className="col-sm-4">فیلترهای گزارش</div>
							<div className="col-sm-4 text-center mr-b-5">
								<SelectAsync
									defaultValue={!this.isNull(this.state.data.account) ? [{ value: this.state.data.account.id, label: this.state.data.account.name }] : null}
									isMulti={false}
									placeholder="انتخاب طرف حساب"
									defaultOptions
									loadOptions={this.loadAccountOptions}
									onChange={e => this.state.accountId = e.value}
								/>
							</div>
							<div className="col-sm-4">
							</div>
							<div className="clear" style={{ clear: "both" }}></div>
							<div className="col-sm-4">
								ورود و خروج کالا
							</div>
							<div className="col-sm-4 text-center">
								از
								<DatePicker
									inputReadOnly={true}
									className="range-from-example text-center mr-l-5 mr-r-5"
									style={{ border: "solid 1px #ccc" }}
									placeholder={"تاریخ"}
									isGregorian={false}
									showTodayButton={true}
									timePicker={false}
									onChange={(e) => { this.state.fromDate = e }}
									value={this.getFormatedDateForDatePicker(this.state.fromDate)}
								/>
								تا
								<DatePicker
									inputReadOnly={true}
									className="range-to-example text-center mr-r-5"
									style={{ border: "solid 1px #ccc" }}
									placeholder={"تاریخ"}
									isGregorian={false}
									showTodayButton={true}
									timePicker={false}
									onChange={(e) => { this.state.toDate = e }}
									value={this.getFormatedDateForDatePicker(this.state.toDate)}
								/>
								<a className="hand mr-r-5" onClick={e => this.getData()}><i className="fa fa-search"></i></a>
							</div>
							<div className="col-sm-4 text-left">
								<button className="btn btn-no-frame btn-smoke hand" onClick={e => this.onPrint()} title="چاپ">
									<span className="fa fa-print"></span>
								</button>
								<button className="btn btn-no-frame btn-smoke hand" onClick={e => this.onPdf()} title="PDF">
									<span className="fa fa-file-pdf-o"></span>
								</button>
								<button className="btn btn-no-frame btn-smoke hand" onClick={e => this.onExcel()} title="اکسل">
									<span className="fa fa-file-excel-o"></span>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-sm-12">
					{this.createTableHeader([
						{ "w": '2 text-center', "f": "number", "c": "شماره حواله" },
						{ "w": '2 text-center', "f": "date", "c": "تاریخ حواله" },
						{ "w": 2, "f": "warehouseName", "c": "آیتم" },
						{ "w": '2 text-center', "f": "", "c": "ورود" },
						{ "w": '2 text-center', "f": "", "c": "خروج" },
						{ "w": '2 text-center', "f": "type", "c": "نوع" },
					], false)}
					{this.state.data.records.map(hit =>
						<div key={hit.id}>
							<div className="row tb-row">
								<div className="col-xs-2 text-center">{hit.number}</div>
								<div className="col-xs-2 text-center">{hit.date}</div>
								<div className="col-xs-2">{hit.warehouseName}</div>
								<div className="col-xs-2 text-center">{this.money(hit.inAmount)}</div>
								<div className="col-xs-2 text-center">{this.money(hit.outAmount)}</div>
								<div className="col-xs-2 text-center">{hit.typeStr}</div>

							</div>
						</div>
					)}
				</div>
			</div>
		</div>
	}
	render() {
		if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

		let contents = this.state.loading ? this.renderLoading() :
			[
				this.state.lockScreen === 1 && this.lockScreen(),
				<Header data={this.state.data} />,
				this.renderForm(),
				<Footer />
			];

		return contents;
	}
}